export enum CustomerType {
  Type1 = 'customer',
  Type2 = 'Channel Patner',
}
